"use strict";
/**
 * API helper functions for Everspring Program Mapping endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.everspringMappingApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
let mappingsCache = null;
exports.everspringMappingApi = {
    /**
     * Clears in-memory cache (used by tests).
     */
    clearCache: () => {
        mappingsCache = null;
    },
    /**
     * Get all Everspring program mappings.
     * Matches legacy Angular endpoint:
     * /everspringProgramMapping/everspringProgramMappings
     */
    getAllMappings: () => {
        if (!mappingsCache) {
            mappingsCache = apiClient_1.apiClient
                .get(`/everspringProgramMapping/everspringProgramMappings`)
                .then(data => data.map(apiMappers_1.mapEverspringProgramMapping));
        }
        return mappingsCache;
    },
    /**
     * Get all mappings for an academic program.
     * Legacy Angular loads all mappings then filters by academicProgramId in app state.
     */
    getMappingsByAcademicProgram: (academicProgramId) => __awaiter(void 0, void 0, void 0, function* () {
        (0, validation_1.validateId)(academicProgramId, 'Academic Program ID');
        const mappings = yield exports.everspringMappingApi.getAllMappings();
        return mappings.filter(mapping => mapping.academicProgramId === academicProgramId);
    }),
    /**
     * Get mappings filtered by academic program and program name
     */
    getMappingsByAcademicProgramAndProgram: (academicProgramId, program) => __awaiter(void 0, void 0, void 0, function* () {
        (0, validation_1.validateId)(academicProgramId, 'Academic Program ID');
        const mappings = yield exports.everspringMappingApi.getMappingsByAcademicProgram(academicProgramId);
        return mappings.filter(mapping => mapping.program === program);
    }),
    /**
     * Get mappings filtered by academic program, program, and specialization
     */
    getMappingsByAcademicProgramAndProgramAndSpecialization: (academicProgramId, program, specialization) => __awaiter(void 0, void 0, void 0, function* () {
        (0, validation_1.validateId)(academicProgramId, 'Academic Program ID');
        const mappings = yield exports.everspringMappingApi.getMappingsByAcademicProgramAndProgram(academicProgramId, program);
        return mappings.filter(mapping => (mapping.specialization || '') === specialization);
    }),
};
